import React from 'react';

import { DisplayButton } from 'components/buttons';

const CancelButton = () => (
  <DisplayButton text="N" />
);

export default CancelButton;



// WEBPACK FOOTER //
// ./src/components/buttons/CancelButton/CancelButton.js